import { useState } from "react";

import { AdminManagementTypes } from "../../utils/constants";
import AdminDocumentManagementScreen from "../AdminDocumentManagementScreen/AdminDocumentManagementScreen";
import InitialLayout from "../InitialLayout/InitialLayout";
import { MainScreenContext } from "../ScreenContext/ScreenContext";

function AdminDocumentManagement(props: any) {
  const screenHook = useState(AdminManagementTypes.DOCUMENT_VALIDATION);
  return (
    <MainScreenContext.Provider value={screenHook}>
      <InitialLayout
        isAdmin={true}
        userInfo={props.userInfo}
        updateLogged={props.updateLogged}
      >
        <AdminDocumentManagementScreen
          userProfileMe={props.userInfo.profile}
          userInfo={props.userInfo}
        />
      </InitialLayout>
    </MainScreenContext.Provider>
  );
}

export default AdminDocumentManagement;
